// extracted by mini-css-extract-plugin
export default {"container":"Dp-z","ratingLayout":"Ep-z","ratingLabel":"Fp-z","nonInteractiveRatingLabel":"Gp-z"};